<template>
    <div class="wrapper">
        <div name="center" class="home">
            <register 
                v-if="centerId !== null && groupId !== null"
                :centerId="centerId"
                :groupId="groupId"
                @onComplete="onComplete"
                @onError="onError"
            />
            <page-footer 
                :state="0"
            />
            <complete-modal 
                v-if="isModal"
                @onClose="onModalClose"
                :title="title"
                :message="message"
                :isError="isError"
            />
        </div>
    </div>

</template>

<script>
import Register from '@/components/organisms/CenterRegister'
import PageFooter from '@/components/molecules/PageFooter'
import CompleteModal from '@/components/modals/CompleteModal'
import Constant from '@/constant';

export default {
    name: 'center',
    components: {
        Register,
        CompleteModal,
        PageFooter
    },
    data: function()
    {
        return {
            centerId: null,
            groupId: null,
            isAuth: false,
            isModal: false,
            isError: false,
            title: '',
            message: ''
        }
    },
    mounted: function()
    {
        this.centerId = this.$route.params.centerid;
        this.groupId = this.$route.params.groupid;
        if(this.centerId != null && this.centerId != '' && this.centerId != undefined && 
            this.groupId != null && this.groupId != '' && this.groupId != undefined )
        {
            this.isAuth = true;
            this.$store.commit(Constant.INITIALIZE_PROFILE_SPECIFY);
            this.$store.commit(Constant.INITIALIZE_AGREEMENTS);
        }
        else
        {
            alert("잘못된 경로입니다.")
            this.isAuth = false;
        }
    },
    methods: {
        onComplete: function()
        {
            this.$store.commit(Constant.INITIALIZE_PROFILE_SPECIFY);
            this.$store.commit(Constant.INITIALIZE_AGREEMENTS);
            this.isError = false;
            this.isModal = true;
        },
        onError: function(title, message)
        {
            this.title = title;
            this.message = message;
            this.isError = true;
            this.isModal = true;
        },  
        onModalClose: function()
        {
            this.isError = false;
            this.title = '';
            this.message = '';
            this.isModal = false;
        }
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .home {
        width: 100%;
    }

    @media (min-width: 600px) {
        .home {
            width: 600px;
        }

    }
</style>


// WEBPACK FOOTER //
// src/page/Center.vue